import axios from 'axios';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Container } from 'react-bootstrap'
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import { url } from '../constants';

const Orders = () => {
    const navigate = useNavigate()
    const [orders, setOrders] = useState([])
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
    const getOrders = async () => {
        await axios({
            url:`${url}/api/orders/`,
            method:'POST',
            headers: {'Content-Type': 'application/json', 'Authorization':`Bearer ${userInfo.token}`}
        }).then(res => setOrders(res.data)).catch(err => alert('failed to get orders'))
    }
    useEffect(()=>{
        if(userInfo){
            getOrders()
        }
        // eslint-disable-next-line
    },[userInfo])
  return (
    <Container>
        {orders.length > 0 ?
        <Table responsive striped bordered hover variant="dark">
            <thead>
                <tr>
                    <th>Full Name</th>
                    <th>Product</th>
                    <th>Total</th>
                    <th>Ordered On</th>
                    <th>Delivered</th>
                </tr>
            </thead>
            <tbody>
                {orders.map(item => (
                    <tr key={item.id}>
                        <td>{item.email}</td>
                        <td>
                            {item.orderItem?.map(product => (
                                <p style={{marginBottom:'0px', backgroundColor:'transparent', width:'max-content'}} key={product.id}>{product.product} : {product.qty} x {product.price}</p>
                            ))}
                        </td>
                        <td>{item.total}</td>
                        <td>{new Date(item.created_at).getDate()}/{new Date(item.created_at).getMonth()}/{new Date(item.created_at).getFullYear()}</td>
                        <td>{item.delivered}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        :
        <>
        {userInfo ?
            <h4 className='text-center'>No orders yet ! <span style={{color:'var(--border)', cursor:'pointer'}} onClick={()=>navigate('/WebShop')}>lets make one.</span></h4>
            :
            <h4 className='text-center'>Please <span style={{color:'var(--border)', cursor:'pointer'}} onClick={()=>navigate('/Authentication')}>login</span> first to see orders lets make one.</h4>
        }
        </>
        }
    </Container>
  )
}

export default Orders